// @flow
import {Link, Route, Switch} from "react-router-dom"
import {containers} from "@swarm2/core"
import * as React from "react"

import {Achievements, AchievementsToast} from "../achievements"
import {CharacterRO, CharacterRW} from "./CharacterView"
import * as Util from "../common"
import {StatisticsView} from "../statistics"
import {UnitsRouter} from "../units"
import CombatRouter from "../combat"
import {assert} from "@swarm2/assert"

const M = Util.intlMessages("view.CharacterRouter")

function NotYoursView(props) {
  const {charId, location} = props
  const url =
    location && location.pathname
      ? location.pathname.replace(/^\/p\//, "/c/")
      : "/c/" + charId
  return (
    <div>
      <M
        id="notyours"
        values={{
          link: (
            <Link to={url}>
              <M id="notyours.link" />
            </Link>
          ),
        }}
      />
    </div>
  )
}

export const CharacterRouter = containers.characters.CharacterRouter(props => {
  if (props.isError) return <Util.Error error={props} />
  const {charId, isAuthChar, readonly, match, location} = props
  assert(readonly != null, "CharacterRouter.readonly is required")
  const route = Wrapped => props => <Wrapped {...props} readonly={readonly} />
  if (!readonly && !isAuthChar) {
    return <NotYoursView charId={charId} location={location} />
  }
  //  <ActionErrorsView />
  return (
    <div>
      <AchievementsToast charId={charId} />
      <Switch>
        {/* readonly's done differently here because legacy - it was one of the
          first pages I wrote. TODO: rewrite it like the others. */}
        <Route
          path={match.path}
          exact
          component={readonly ? CharacterRO : CharacterRW}
        />
        <Route path={match.path + "/units"} render={route(UnitsRouter)} />
        <Route
          path={match.path + "/achievements"}
          component={Achievements}
          render={route(Achievements)}
        />
        <Route
          exact
          path={match.path + "/statistics"}
          render={route(StatisticsView)}
        />
        <Route
          path={match.path + "/statistics/:tabName"}
          render={route(StatisticsView)}
        />
        <Route path={match.path + "/combat"} render={route(CombatRouter)} />
        <Route component={Util.NotFoundView} />
      </Switch>
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/characters/CharacterRouter.js